import { __assign } from "tslib";
import { CURRENCY_HEADER_NAME, MULTI_LANG_HEADER_NAME } from '@wix/wixstores-client-core';
import { getApiBaseUrl } from '../utils/getWixApiBaseUrl';
export function getSDKAuthAndHost(siteStore) {
    return {
        auth: {
            getAuthHeaders: function () {
                var _a, _b;
                var currencyHeader = siteStore.getCurrencyHeader();
                var multiLangHeader = siteStore.getMultiLangHeader();
                return {
                    headers: __assign(__assign({ Authorization: siteStore.instanceManager.getInstance() }, (currencyHeader ? (_a = {}, _a[CURRENCY_HEADER_NAME] = currencyHeader, _a) : {})), (multiLangHeader ? (_b = {}, _b[MULTI_LANG_HEADER_NAME] = multiLangHeader, _b) : {})),
                };
            },
        },
        host: {
            apiBaseUrl: getApiBaseUrl(siteStore.isSSR(), siteStore.location.baseUrl),
        },
    };
}
//# sourceMappingURL=getSDKAuthAndHost.js.map